import React from 'react';

import { cssMap } from '@compiled/react';
import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { Box, Text } from '@atlaskit/primitives/compiled';
import { Card } from '@atlaskit/smart-card';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	container: {
		paddingBottom: token('space.100'),
		font: token('font.body.large'),
	},
	cardContainer: {
		display: 'inline-flex',
		// Recommended way to override the wrapper in the SmartCard component and is necessary for the SmartCard to render
		// inline with the text to match designs.
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& .loader-wrapper': {
			display: 'flex',
		},
	},
});

type Props = {
	sourceUrl?: string;
};

export const CardGroupContext = ({ sourceUrl }: Props): React.JSX.Element | null => {
	di(Card);

	const { formatMessage } = useIntl();

	if (!sourceUrl) {
		return null;
	}

	return (
		<Box xcss={styles.container}>
			<Text>
				{formatMessage(messages.contextMessage, {
					card: () => (
						<Box xcss={styles.cardContainer}>
							<Card url={sourceUrl} appearance="inline" truncateInline={true} />
						</Box>
					),
				})}
			</Text>
		</Box>
	);
};
